import { useEffect, useState } from "react";
import { settingsAPI } from "../api/settings";
import { useLatestQuery } from "../api/useLatestQuery";
import { CvpSettings } from "./CvpSettings";
import { sanitizeSettings } from "./sanitizeSettings";
import { addSettingsSetCallback, settings } from "./settings";

export function useSettings() {
  // trigger rerender when new settings are available
  // this lets components that are not observers also rerender
  const [_, setRerender] = useState(0);

  useEffect(() => {
    return addSettingsSetCallback(() => {
      setRerender((n) => n + 1);
    });
  }, []);

  return settings.get();
}

export function useGeneralSettingsForConcern(idConcern: number) {
  const { data, isFetched } = useLatestQuery(
    ["settingsAPI.getSettingsCompleteAsDictionary", idConcern],
    () =>
      settingsAPI.getSettingsCompleteAsDictionary({
        idConcernOverride: idConcern,
        idEmbed: null, // we only get the general settings for other concern
      })
  );

  if (!isFetched) return null;

  const finalCompleteSettings = sanitizeSettings(data.item as CvpSettings);
  return sanitizeSettings(finalCompleteSettings);
}
